import { render, staticRenderFns } from "./ListInventoryResumeComponent.vue?vue&type=template&id=08c0424d&scoped=true&"
import script from "./ListInventoryResumeComponent.vue?vue&type=script&lang=js&"
export * from "./ListInventoryResumeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c0424d",
  null
  
)

export default component.exports